//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getDetail(key){
    return _axios({
        url: `/api/merchandiseSales/getDetail?id=${key}`,
        method: 'get'
    })
}

//getMerchandiseSalesByCustomerId
export function getMerchandiseSalesByCustomerId(key){
    return _axios({
        url: `/api/merchandiseSales/getMerchandiseSalesByCustomerId?id=${key}`,
        method: 'get'
    })
}

export function submit(data){
    return _axios({
        url: `/api/merchandiseSales/submit`,
        method: 'post',
        data:data
    })
}

//customerSalesSubmit
export function customerSalesSubmit(data){
    return _axios({
        url: `/api/merchandiseSales/customerSalesSubmit`,
        method: 'post',
        data:data
    })
}
